import React from 'react';
import { CollapseTriggerProps } from '../types';

export const CollapseTrigger = ({ children }: CollapseTriggerProps): JSX.Element => {
  return <>{children}</>;
};
